// Auto-generated from network-ledger.html. Verbatim redesign import. Do NOT edit.
export const MARKUP = `
<header class="page-header">
<canvas aria-hidden="true" class="page-header-canvas" id="netLedgerHeroCanvas"></canvas>
<div class="page-header-veil"></div>
<div class="wrap">
<h1 class="reveal" style="max-width:24ch">One Asset. <span class="accent">Every</span> Network.</h1>
<p class="lede reveal">T-REX Ledger holds the golden record for every asset. Wherever an asset goes, every chain checks that record before a transfer clears.</p>
<div class="cta-row reveal">
<a class="btn btn-primary" href="/contact">Talk to an expert</a>
<a class="btn btn-ghost" href="https://docs.t-rex.network/" rel="noopener noreferrer" target="_blank">Read the technical brief</a>
</div>
</div>
</header>

<section class="section section-day gr-section">
<div class="wrap">
<div class="section-head reveal" style="text-align:center;max-width:760px;margin-left:auto;margin-right:auto">
<h2 class="head" style="margin:0 auto;max-width:24ch">Anchored to the Ledger,<br/>compliant <span class="accent">everywhere</span>.</h2>
<p class="lede" style="margin:18px auto 0">Every asset has one canonical record on the Ledger. Every transfer, on any chain, queries that record before it clears, so ownership and eligibility resolve to a single source the whole Network references. Within the Network this record is canonical; whether it is also the legally authoritative register depends on each asset's governing documents and applicable law.</p>
</div>
</div>
<div class="gr-stage-full reveal" id="grStage">
<canvas aria-hidden="true" id="grCanvas"></canvas>
</div>
</section>

<section class="section section-day">
<div class="wrap">
<div class="prob-grid">
<div class="section-head reveal">
<h2 class="head" style="max-width:24ch">Multi-chain distribution needs a <span class="accent">shared record</span>.</h2>
<p class="lede">Asset issuers distribute regulated assets across multiple blockchains to reach investors and venues, but each blockchain is not aware of compliance rules running on the others. Without one record every chain can reference, each network keeps its own copy of eligibility, transfer rules, and ownership, and those copies drift apart. Cross-chain reconciliation of compliance is a hard technical problem. That is what the T-REX Ledger solves.</p>
</div>
<div class="prob-visual reveal">
<div class="cmp-diagram">
<svg height="100%" style="fill-rule:evenodd;clip-rule:evenodd;" version="1.1" viewbox="0 0 360 200" width="100%" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<g opacity="0.85">
<g>
<path d="M180,100L180,44" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.4px;"></path>
<path d="M180,100L180,156" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.4px;"></path>
</g>
<g transform="matrix(1,0,0,1,-1,0)">
<g transform="matrix(1.03,0,0,1.03,-5.4,-3)"><path d="M180,100L80,100" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.4px;"></path></g>
<g transform="matrix(1.05,0,0,1.05,-9,-5)"><path d="M180,100L280,100" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.4px;"></path></g>
</g>
</g>
<g>
<g transform="matrix(1,0,0,1,0,5)"><circle cx="180" cy="68" r="2.6" style="fill:rgb(255,122,51);"></circle></g>
<g transform="matrix(1,0,0,1,0,-5)"><circle cx="180" cy="132" r="2.6" style="fill:rgb(255,122,51);"></circle></g>
<circle cx="126" cy="100" r="2.6" style="fill:rgb(255,122,51);"></circle>
<circle cx="234" cy="100" r="2.6" style="fill:rgb(255,122,51);"></circle>
</g>
<circle cx="180" cy="100" r="34" style="fill:none;stroke:rgb(255,122,51);stroke-opacity:0.5;stroke-width:1.3px;"></circle>
<circle cx="180" cy="100" r="15" style="fill:url(#_Radial1);"></circle>
<g transform="matrix(1,0,0,1,180,40)"><g><path d="M0,-14L14,-7L0,0L-14,-7L0,-14Z" style="fill:rgb(244,229,194);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path><path d="M-14,-7L0,0L0,16L-14,9L-14,-7Z" style="fill:rgb(232,217,184);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path><path d="M14,-7L0,0L0,16L14,9L14,-7Z" style="fill:rgb(216,199,154);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path></g></g>
<g transform="matrix(1,0,0,1,180,160)"><g><path d="M0,-14L14,-7L0,0L-14,-7L0,-14Z" style="fill:rgb(244,229,194);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path><path d="M-14,-7L0,0L0,16L-14,9L-14,-7Z" style="fill:rgb(232,217,184);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path><path d="M14,-7L0,0L0,16L14,9L14,-7Z" style="fill:rgb(216,199,154);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path></g></g>
<g transform="matrix(1,0,0,1,64,100)"><g transform="matrix(1,0,0,1,0,-1)"><path d="M0,-14L14,-7L0,0L-14,-7L0,-14Z" style="fill:rgb(244,229,194);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path><path d="M-14,-7L0,0L0,16L-14,9L-14,-7Z" style="fill:rgb(232,217,184);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path><path d="M14,-7L0,0L0,16L14,9L14,-7Z" style="fill:rgb(216,199,154);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path></g></g>
<g transform="matrix(1,0,0,1,296,100)"><g transform="matrix(1,0,0,1,0,-1)"><path d="M0,-14L14,-7L0,0L-14,-7L0,-14Z" style="fill:rgb(244,229,194);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path><path d="M-14,-7L0,0L0,16L-14,9L-14,-7Z" style="fill:rgb(232,217,184);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path><path d="M14,-7L0,0L0,16L14,9L14,-7Z" style="fill:rgb(216,199,154);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path></g></g>
<g>
<g transform="matrix(1,0,0,1,179.75,22)"><text style="font-family:'JetBrains Mono', monospace;font-size:10px;fill:rgb(21,16,42);" x="-21px" y="0px">Chain A</text></g>
<g transform="matrix(1,0,0,1,64,126)"><text style="font-family:'JetBrains Mono', monospace;font-size:10px;fill:rgb(21,16,42);" x="-21px" y="0px">Chain B</text></g>
<g transform="matrix(1,0,0,1,296,126)"><text style="font-family:'JetBrains Mono', monospace;font-size:10px;fill:rgb(21,16,42);" x="-21px" y="0px">Chain C</text></g>
<g transform="matrix(1,0,0,1,179.97,190)"><text style="font-family:'JetBrains Mono', monospace;font-size:10px;fill:rgb(21,16,42);" x="-21px" y="0px">Chain D</text></g>
</g>
<defs>
<radialgradient cx="0" cy="0" gradienttransform="matrix(21,0,0,21,176.4,95.2)" gradientunits="userSpaceOnUse" id="_Radial1" r="1"><stop offset="0" style="stop-color:rgb(255,217,160);stop-opacity:1"></stop><stop offset="0.42" style="stop-color:rgb(255,122,51);stop-opacity:1"></stop><stop offset="1" style="stop-color:rgb(194,82,28);stop-opacity:1"></stop></radialgradient>
</defs>
</svg>
</div>
</div>
</div>
</div>
</section>

<section class="section section-night">
<div class="wrap">
<div class="section-head reveal">
<h2 class="head" style="max-width:26ch">Build compliance once. <span class="accent">Deploy</span> across chains.</h2>
<p class="lede">Institutions manage one authoritative compliance state, while assets move across multiple networks.</p>
</div>
<div class="orch-diagram reveal">
<div class="orch-diagram-inner">

<div class="ocl-layer">
<div class="ocl-layer-id">
<span class="ocl-layer-name">T-REX Ledger</span>
<span class="ocl-layer-sub">The compliance layer</span>
</div>
</div>

<div aria-hidden="true" class="ocl-connectors">
<span><i class="ocl-dot"></i></span><span><i class="ocl-dot"></i></span><span><i class="ocl-dot"></i></span><span><i class="ocl-dot"></i></span><span><i class="ocl-dot"></i></span><span><i class="ocl-dot"></i></span><span><i class="ocl-dot"></i></span><span><i class="ocl-dot"></i></span><span><i class="ocl-dot"></i></span>
</div>

<div class="ocl-chains">
<div class="ocl-chain"><img class="ocl-logo" data-chain="Ethereum" src="/brand/chains/ethereum.svg" alt="Ethereum" loading="lazy" /></div>
<div class="ocl-chain"><img class="ocl-logo" data-chain="Polygon" src="/brand/chains/polygon.svg" alt="Polygon" loading="lazy" /></div>
<div class="ocl-chain"><img class="ocl-logo" data-chain="Avalanche" src="/brand/chains/avalanche.svg" alt="Avalanche" loading="lazy" /></div>
<div class="ocl-chain"><img class="ocl-logo" data-chain="Optimism" src="/brand/chains/optimism.svg" alt="Optimism" loading="lazy" /></div>
<div class="ocl-chain"><img class="ocl-logo" data-chain="Stellar" src="/brand/chains/stellar.svg" alt="Stellar" loading="lazy" /></div>
<div class="ocl-chain"><img class="ocl-logo" data-chain="Solana" src="/brand/chains/solana.svg" alt="Solana" loading="lazy" /></div>
<div class="ocl-chain"><img class="ocl-logo" data-chain="Hedera" src="/brand/chains/hedera.svg" alt="Hedera" loading="lazy" /></div>
<div class="ocl-chain"><img class="ocl-logo" data-chain="Casper" src="/brand/chains/casper.svg" alt="Casper" loading="lazy" /></div>
<div class="ocl-chain"><img class="ocl-logo ocl-logo-wide" data-chain="Base" src="/brand/chains/base.svg" alt="Base" loading="lazy" /></div>
</div>
</div>
</div>
<div class="orch-points reveal">
<div class="opt-card">
<span aria-hidden="true" class="opt-ico">
<svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" viewbox="0 0 24 24"><circle cx="12" cy="12" r="9"></circle><path d="M3 12h18"></path><path d="M12 3c2.5 2.5 3.8 5.7 3.8 9s-1.3 6.5-3.8 9c-2.5-2.5-3.8-5.7-3.8-9S9.5 5.5 12 3Z"></path></svg>
</span>
<span class="opt-h">Chain-agnostic by design.</span>
<p>Works with the chains institutions already operate on, and the chains they are about to.</p>
</div>
<div class="opt-card">
<span aria-hidden="true" class="opt-ico">
<svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" viewbox="0 0 24 24"><path d="M12 3 3 7.5 12 12l9-4.5L12 3Z"></path><path d="M3 12l9 4.5L21 12"></path><path d="M3 16.5 12 21l9-4.5"></path></svg>
</span>
<span class="opt-h">One source of truth.</span>
<p>Eligibility, transfer rules, and investor data, accessible from every connected ecosystem.</p>
</div>
<div class="opt-card">
<span aria-hidden="true" class="opt-ico">
<svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" viewbox="0 0 24 24"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z"></path><path d="M14 3v5h5"></path><path d="m9 14 2 2 4-4"></path></svg>
</span>
<span class="opt-h">The audit trail stays intact.</span>
<p>Issuers and transfer agents stop running disconnected systems, regardless of where the asset moves.</p>
</div>
</div>
</div>
</section>

<section class="section section-day">
<div class="wrap">
<div class="section-head reveal">
<h2 class="head">ERC-3643 gives the asset its rules. T-REX makes them work <span class="accent">everywhere</span>.</h2>
<p class="lede">ERC-3643 gives each asset its identity, permissions and lifecycle controls onchain. T-REX Ledger anchors those controls to one authoritative record, so they remain consistent across every connected chain and application.</p>
</div>
<div class="steps reveal">
<div class="step">
<span class="step-n">01</span>
<div class="step-body">
<h3>Permissions, connected once</h3>
<p class="step-base">Administrators, transfer agents and custodians receive their roles through ERC-3643.</p>
<p class="step-add">T-REX Ledger carries those permissions across connected chains, removing the need to configure and reconcile each environment separately.</p>
</div>
</div>
<div class="step">
<span class="step-n">02</span>
<div class="step-body">
<h3>Identity, referenced everywhere</h3>
<p class="step-base">Each asset has an onchain identity with its associated credentials, records and attestations.</p>
<p class="step-add">Anchored to the Ledger, that identity can be read consistently across every connected chain and application.</p>
</div>
</div>
<div class="step">
<span class="step-n">03</span>
<div class="step-body">
<h3>Corporate actions, executed once</h3>
<p class="step-base">Minting, burning, recovery, distributions and other lifecycle actions run through ERC-3643.</p>
<p class="step-add">With the authoritative record anchored to the Ledger, each action is reflected across the asset's connected environments without separate per-chain updates.</p>
</div>
</div>
</div>
</div>
</section>

<section class="section section-night apex-monument" id="apex">
<div class="wrap">
<div class="apex-inner">
<div class="apex-figure reveal">
<div aria-label="$100,000,000,000 committed" class="apex-number" id="apexNumber">
<span class="cur">$</span><span id="apexCount">90,000,000,000</span>
</div>
</div>
<div class="apex-support reveal">
<p><strong>Apex Group</strong>, servicing $3.5 trillion in assets, has committed to the T-REX Network, with the Ledger as its book of record, targeting $100B in tokenized assets. Infrastructure scales when the biggest institutions stake their own book on it.</p>
<a class="apex-cta" href="https://www.apexgroup.com/insights/apex-group-to-enable-global-distribution-of-tokenized-funds-using-the-t-rex-ledger-as-its-multi-chain-orchestration-layer/" rel="noopener noreferrer" target="_blank">Read the Apex announcement</a>
</div>
</div>
</div>
</section>

<section class="section section-day">
<div class="wrap">
<div class="section-head reveal">
<h2 class="head">Built for regulated <span class="accent">market operators</span>.</h2>
</div>
<div class="opanels" id="opPanels">
<article class="opanel active" data-panel="1" tabindex="0">
<div aria-hidden="true" class="omotif">
<svg preserveaspectratio="xMaxYMax meet" viewbox="0 0 300 300">
<path class="mid" d="M30 96 L150 44 L270 96 Z"></path><path class="mid" d="M40 112h220"></path>
<path d="M62 112v118M104 112v118M146 112v118M188 112v118M230 112v118"></path>
<path class="mid" d="M40 230h220"></path><path class="dim" d="M30 244h240"></path><path class="dim" d="M22 258h256"></path>
</svg>
</div>
<div class="opanel-inner">
<div class="opanel-spine">Transfer agents</div>
<div class="opanel-content">
<h3>One register, every chain.</h3>
<p>Maintain the register and process corporate actions against one anchored cap table, so positions stay correct on every chain the asset reaches, without reconciling each chain by hand.</p>
</div>
</div>
</article>
<article class="opanel" data-panel="2" tabindex="0">
<div aria-hidden="true" class="omotif">
<svg preserveaspectratio="xMaxYMax meet" viewbox="0 0 300 300">
<path class="mid" d="M150 40 L246 78 V150 C246 210 200 246 150 262 C100 246 54 210 54 150 V78 Z"></path>
<path d="M150 96 L210 120 V160 C210 196 182 220 150 232 C118 220 90 196 90 160 V120 Z"></path>
<circle cx="150" cy="150" r="14"></circle><path class="dim" d="M150 164v26"></path>
</svg>
</div>
<div class="opanel-inner">
<div class="opanel-spine">Custodians</div>
<div class="opanel-content">
<h3>Holdings that reconcile themselves.</h3>
<p>Safekeep tokenized assets against one onchain record, so custodied positions verify to the same source of truth no matter which chain they sit on.</p>
</div>
</div>
</article>
<article class="opanel" data-panel="3" tabindex="0">
<div aria-hidden="true" class="omotif">
<svg preserveaspectratio="xMaxYMax meet" viewbox="0 0 300 300">
<path class="dim" d="M40 236h220"></path>
<path class="mid" d="M70 236v-70M118 236v-120M166 236v-92M214 236v-150"></path>
<path d="M70 166 L118 116 L166 144 L214 86"></path>
<circle cx="70" cy="166" r="5"></circle><circle cx="118" cy="116" r="5"></circle><circle cx="166" cy="144" r="5"></circle><circle cx="214" cy="86" r="5"></circle>
</svg>
</div>
<div class="opanel-inner">
<div class="opanel-spine">Asset managers</div>
<div class="opanel-content">
<h3>Issue once, reach everywhere.</h3>
<p>Bring regulated assets onchain once and distribute across every connected chain, while keeping eligibility, the cap table, and control anchored in one place.</p>
</div>
</div>
</article>
<article class="opanel" data-panel="4" tabindex="0">
<div aria-hidden="true" class="omotif">
<svg preserveaspectratio="xMaxYMax meet" viewbox="0 0 300 300">
<circle class="mid" cx="150" cy="150" r="14"></circle>
<circle class="dim" cx="70" cy="80" r="9"></circle><circle class="dim" cx="232" cy="96" r="9"></circle><circle class="dim" cx="96" cy="226" r="9"></circle><circle class="dim" cx="220" cy="220" r="9"></circle>
<path d="M150 150 L70 80M150 150 L232 96M150 150 L96 226M150 150 L220 220"></path>
</svg>
</div>
<div class="opanel-inner">
<div class="opanel-spine">Distribution</div>
<div class="opanel-content">
<h3>List without holding the risk.</h3>
<p>Offer the asset to investors knowing eligibility and transfer rules are enforced by the asset itself against the Ledger, so the venue does not have to police compliance on every trade.</p>
</div>
</div>
</article>
</div>
</div>
</section>

<section class="section section-day">
<div class="wrap">
<div class="section-head center reveal">
<h2 class="head">Frequently asked <span class="accent">questions</span>.</h2>
</div>
<div class="faq reveal">
<details class="faq-item"><summary>Is the Ledger another blockchain I have to migrate to?</summary><div class="faq-a">No. An asset is issued first on the T-REX Ledger using the full ERC-3643 feature set (T-REX v5), then deployed onto connected chains as a lightweight ERC-20 with a compliance hook back to the Ledger. You issue once and reach many chains, rather than migrating between them.</div></details>
<details class="faq-item"><summary>Which chains are connected?</summary><div class="faq-a">Mainnet is not yet live. Once it launches, cross-chain connectivity for ERC-3643 assets will use Chainlink's interoperability standard, connecting the T-REX Ledger to the networks that standard supports, currently more than 60 chains. Connected chains consume a compliance validation from the T-REX Ledger, which remains the authoritative record for eligibility and transfer rules.</div></details>
<details class="faq-item"><summary>Who runs the Ledger?</summary><div class="faq-a">The Ledger is governed by the Network, not by any single company. No technology provider operates the Ledger or can unilaterally change protocol rules.</div></details>
<details class="faq-item"><summary>Does the issuer keep control of the asset?</summary><div class="faq-a">Yes. The issuer owns the smart contracts and decides which agents, administrators, transfer agents, and custodians have rights and what they can do. Service providers operate the rails on the issuer's behalf; the issuer retains control.</div></details>
<details class="faq-item"><summary>Is the data on the Ledger private?</summary><div class="faq-a">Confidentiality is an opt-in feature. Issuers who want an asset to remain private can enable a confidentiality layer built on Fully Homomorphic Encryption, which lets compliance be enforced on encrypted data without decrypting it. It is not enabled by default for every asset on the Ledger.</div></details>
</div>
</div>
</section>

<section class="section section-night center">
<div class="wrap">
<div class="reveal">
<h2 class="head">Orchestrate compliance across <span class="accent">every chain</span> your assets live on.</h2>
<p class="lede" style="margin-top:clamp(20px,3vh,28px)">Book a 30-minute institutional briefing. We will walk your asset through the Ledger and answer the operational, compliance, and integration questions in one session.</p>
<div class="cta-row" style="justify-content:center;margin-top:clamp(34px,5vh,52px);display:flex;flex-wrap:wrap;gap:14px">
<a class="btn btn-primary" href="/contact">Book a call</a>
<a class="btn btn-ghost" href="https://docs.t-rex.network/" rel="noopener noreferrer" target="_blank">Read technical details</a>
</div>
</div>
</div>
</section>
`;
